import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });
api.interceptors.request.use((c) => {
  c.headers["X-Demo-Role"] = localStorage.getItem("afk-role") || "group_exec";
  return c;
});

export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Request failed";

export async function streamResearch(body, { onEvidence, onText, onDone }) {
  const res = await fetch(`${BACKEND}/api/ai/research`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-Demo-Role": localStorage.getItem("afk-role") || "group_exec" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error((await res.json()).detail || "Research failed");
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const chunks = buf.split("\n\n");
    buf = chunks.pop();
    for (const ch of chunks) {
      const ev = (ch.match(/^event: (.*)$/m) || [])[1] || "message";
      const data = (ch.match(/^data: (.*)$/m) || [])[1];
      if (!data) continue;
      const j = JSON.parse(data);
      if (ev === "evidence") onEvidence?.(j);
      else if (ev === "done") onDone?.();
      else onText?.(j.t);
    }
  }
  onDone?.();
}

export const pdfUrl = (id) => `${BACKEND}/api/reports/${id}/pdf?role=${localStorage.getItem("afk-role") || "group_exec"}`;
